/* eslint-disable import/no-anonymous-default-export */
import {
  ADMIN_REGISTER,
  GET_AREA,
  GET_CATEGORY,
  GET_COUNTRY,
  GET_DATA_COUNTS,
  GET_GOVERNORATE,
  SET_USER,
  GET_LANGUAGE_LIST,
  GET_TERMS,
  GET_ALL_USER,
  GET_TAXI_DATA,
  GET_CAR_TOWING_DATA,
  GET_SPARE_PART_DATA,
  GET_CAR_DEALER_DATA,
  GET_CAR_SALE_DATA,
  GET_CAR_RENT_DATA,
  GET_SERVICE_FILTER,
  GET_GARAGE_DATA,
  GET_BUSINESS_DATA,
  GET_CARBRAND_DATA,
  GET_ALL_PRODUCT_PARTS_DATA,
  GET_ALL_PARTS_DATA,
  GET_GARAGE_CATEGORY,
  GET_CAR_DEALER_CATEGORY,
  GET_SPARE_PART_CATEGORY,
  GET_ADMIN_AREA,
  GET_ALL_BUSINESS_DATA_LIST,
  GET_ALL_BUSINESS_CATEGORY,
  GET_SERVICES_DATA,
  ADD_CAR_SERVICES,
  ADD_QUICK_SERVICES,
  GET_PACKAGES_LIST,
  GET_USER_LIST,
  UPDATE_USER_PROFILE,
  GET_SINGLE_GARAGE_OWNER,
  GET_SINGLE_SPARE_PART,
  GET_SINGLE_CAR_RENT_DATA,
  UPDATE_SINGLE_SPARE_PART,
  GET_COUNTRIES_LIST,
  GET_CYCLINDER_LIST,
  GET_MODEL_YEAR_LIST,
  GET_FUEL_TYPE_LIST,
  GET_SEATS_LIST,
  GET_DOOR_LIST,
  GET_COLOR_LIST,
  GET_SAFETY_LIST,
  GET_COMFORT_LIST,
  ADD_COMFORT,
  GET_SINGLE_COMFORT_LIST,
  GET_SINGLE_SAFETY_LIST,
  ADD_COLOR_LIST,
  ADD_SEAT_LIST,
  ADD_DOOR_LIST,
  ADD_FUEL_TYPE,
  ADD_MODEL_YEAR,
  ADD_CYLINDER,
  GET_SINGLE_CYCLINDER_LIST,
  GET_SINGLE_MODEL_YEAR_LIST,
  GET_SINGLE_FUEL_TYPE_LIST,
  GET_SINGLE_DOOR_LIST,
  GET_SINGLE_SEAT_LIST,
  GET_SINGLE_COLOR_LIST,
  UPDATE_COMFORT,
  UPDATE_COLOR_LIST,
  UPDATE_SEAT_LIST,
  UPDATE_DOOR_LIST,
  UPDATE_FUEL_TYPE,
  UPDATE_MODEL_YEAR,
  UPDATE_CYLINDER,
  UPDATE_SAFETY_LIST,
  GET_SINGLE_CAR_BRAND,
  GET_SINGLE_PRODUCT_PART_DATA,
  GET_SERVICE_PROVIDER_LIST,
  GET_SINGLE_SERVICES_DATA,
  GET_SINGLE_QUICK_SERVICE,
  GET_SINGLE_GARAGE_CATEGORY,
  GET_SINGLE_SPARE_PART_CATEGORY,
  GET_SINGLE_CAR_DEALER_CATEGORY,
  GET_SINGLE_CAR_WASH_CATEGORY,
  GET_SINGLE_CAR_INSURANCE_CATEGORY,
  GET_SINGLE_CAR_PROTECTION_CATEGORY,
  GET_SINGLE_AIR_CONDITION_CATEGORY,
  GET_SINGLE_DRIVING_SCHOOL_CATEGORY,
  ADD_TERMS_AND_CONDITION,
  GET_CARBRAND_FILTER,
  GET_SINGLE_CAR_DEALER_DATA,
  GET_SINGLE_CAR_SALE_DATA,
  GET_CARMODEL_DATA,
  CONTACT_LIST,
  SINGLE_AREA,
  GET_DATEWISE_ORDER,
  GET_SINGLE_TAXI_OWNER_DATA,
  GET_SINGLE_CAR_TOWING_OWNER_DATA,
  GET_SINGLE_CAR_WASH,
  GET_SINGLE_CAR_INSURANCE,
  GET_SINGLE_DRIVING_SCHOOL,
  GET_SINGLE_CAR_PROTECTION,
  GET_SINGLE_AIR_CONDITIONING,
  GET_SINGLE_QUICK_SERVICE_OWNER,
  GET_CUSTOM_DATA_COUNTS,
  GET_PROFILE_USER,
  GET_USER_SUBS,
  GET_USER_CARPOSTS,
  GET_LISTING_STATS,
  GET_PLANS_FOR_BUSINESS,
} from '../actions/types';

var initialState = {
  list: [],
};

const homeReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_DATA_COUNTS:
      return {
        ...state,
        dataCounts: action.payload,
      };
    case GET_CATEGORY:
      return {
        ...state,
        categoryList: action.payload,
      };
    case GET_ALL_PARTS_DATA:
      return {
        ...state,
        allSparePartsList: action.payload,
      };
    case GET_CARBRAND_DATA:
      return {
        ...state,
        CarBrandList: action.payload,
      };
    case GET_CARBRAND_FILTER:
      return {
        ...state,
        carsWithBrandFilter: action.payload,
      };
    case GET_ALL_PRODUCT_PARTS_DATA:
      return {
        ...state,
        ProductList: action.payload,
      };
    case ADMIN_REGISTER:
      return {
        ...state,
        registerList: action.payload,
      };
    case GET_SERVICE_FILTER:
      return {
        ...state,
        getServiceFilterList: action.payload,
      };

    case GET_BUSINESS_DATA:
      return {
        ...state,
        businessList: action.payload,
      };
    case GET_ALL_USER:
      return {
        ...state,
        userList: action.payload.response,
      };
    case GET_GARAGE_DATA:
      return {
        ...state,
        list: action.payload,
      };
    case GET_TAXI_DATA:
      return {
        ...state,
        list: action.payload,
      };
    case GET_SINGLE_TAXI_OWNER_DATA:
      return {
        ...state,
        singleTaxiOwner: action.payload,
      };
    case GET_CAR_TOWING_DATA:
      return {
        ...state,
        list: action.payload,
      };
    case GET_SINGLE_CAR_TOWING_OWNER_DATA:
      return {
        ...state,
        singleCarTowingOwner: action.payload,
      };
    case GET_SINGLE_CAR_WASH:
      return {
        ...state,
        singleCarWash: action.payload,
      };
    case GET_SINGLE_CAR_INSURANCE:
      return {
        ...state,
        singleCarInsurance: action.payload,
      };
    case GET_SINGLE_DRIVING_SCHOOL:
      return {
        ...state,
        singleDrivingSchool: action.payload,
      };
    case GET_SINGLE_CAR_PROTECTION:
      return {
        ...state,
        singleCarProtection: action.payload,
      };
    case GET_SINGLE_AIR_CONDITIONING:
      return {
        ...state,
        singleAirCondition: action.payload,
      };
    case GET_SINGLE_QUICK_SERVICE_OWNER:
      return {
        ...state,
        singleQuickServiceOwner: action.payload,
      };
    case GET_SPARE_PART_DATA:
      return {
        ...state,
        list: action.payload,
      };
    case GET_CAR_DEALER_DATA:
      return {
        ...state,
        list: action.payload,
      };
    case GET_SINGLE_CAR_DEALER_DATA:
      return {
        ...state,
        singleCarDealer: action.payload,
      };

    case GET_CAR_SALE_DATA:
      return {
        ...state,
        list: action.payload,
      };
    case GET_SINGLE_CAR_SALE_DATA:
      return {
        ...state,
        singleCarSale: action.payload,
      };

    case GET_CAR_RENT_DATA:
      return {
        ...state,
        list: action.payload,
      };
    case GET_SINGLE_CAR_RENT_DATA:
      return {
        ...state,
        singleCarRent: action.payload,
      };

    case SET_USER:
      return {
        ...state,
        userData: action.payload,
      };
    case GET_COUNTRY:
      return {
        ...state,
        country: action.payload,
      };
    case GET_GOVERNORATE:
      return {
        ...state,
        governorate: action.payload,
      };
    case GET_AREA:
      return {
        ...state,
        area: action.payload,
      };
    case SINGLE_AREA:
      return {
        ...state,
        areaID: action.payload,
      };

    case GET_LANGUAGE_LIST:
      return {
        ...state,
        languageList: action.payload,
      };

    case GET_TERMS:
      return {
        ...state,
        terms: action.payload,
      };
    case GET_GARAGE_CATEGORY:
      return {
        ...state,
        CategoryList: action.payload,
      };
    case GET_SPARE_PART_CATEGORY:
      return {
        ...state,
        CategoryList: action.payload,
      };
    case GET_CAR_DEALER_CATEGORY:
      return {
        ...state,
        CategoryList: action.payload,
      };

    case GET_ADMIN_AREA:
      return {
        ...state,
        allSparePartsList: action.payload,
      };
    case GET_ALL_BUSINESS_DATA_LIST:
      return {
        ...state,
        list: action.payload,
      };
    case GET_ALL_BUSINESS_CATEGORY:
      return {
        ...state,
        CategoryList: action.payload,
      };
    case GET_SERVICES_DATA:
      return {
        ...state,
        ServicesList: action.payload,
      };
    case GET_SINGLE_SERVICES_DATA:
      return {
        ...state,
        singleServiceData: action.payload,
      };
    case GET_SINGLE_QUICK_SERVICE:
      return {
        ...state,
        getSingleQuick: action.payload,
      };
    case GET_SINGLE_GARAGE_CATEGORY:
      return {
        ...state,
        getSingleGarage: action.payload,
      };
    case GET_SINGLE_SPARE_PART_CATEGORY:
      return {
        ...state,
        getSingleSPCategory: action.payload,
      };
    case GET_SINGLE_CAR_DEALER_CATEGORY:
      return {
        ...state,
        getSingleCarDealerCategory: action.payload,
      };
    case GET_SINGLE_CAR_WASH_CATEGORY:
      return {
        ...state,
        getSingleCarWashCategory: action.payload,
      };
    case GET_SINGLE_CAR_INSURANCE_CATEGORY:
      return {
        ...state,
        getSingleCarInsuranceCategory: action.payload,
      };
    case GET_SINGLE_CAR_PROTECTION_CATEGORY:
      return {
        ...state,
        getSingleCarProCat: action.payload,
      };
    case GET_SINGLE_AIR_CONDITION_CATEGORY:
      return {
        ...state,
        getSingleAirConditionCategory: action.payload,
      };
    case GET_SINGLE_DRIVING_SCHOOL_CATEGORY:
      return {
        ...state,
        getSingleDrivingSchoolCat: action.payload,
      };
    case ADD_TERMS_AND_CONDITION:
      return {
        ...state,
        AddTermsAndCondition: action.payload,
      };
    case ADD_CAR_SERVICES:
      return {
        ...state,
        carServices: action.payload,
      };
    case ADD_QUICK_SERVICES:
      return {
        ...state,
        quickServices: action.payload,
      };
    case GET_PACKAGES_LIST:
      return {
        ...state,
        packageList: action.payload,
      };
    case GET_USER_LIST:
      return {
        ...state,
        userDetail: action.payload,
      };
    case UPDATE_USER_PROFILE:
      return {
        ...state,
        updateUserProfile: action.payload,
      };
    case GET_SINGLE_GARAGE_OWNER:
      return {
        ...state,
        garageOwner: action.payload,
      };
    case GET_SINGLE_SPARE_PART:
      return {
        ...state,
        singleSparePart: action.payload,
      };
    case UPDATE_SINGLE_SPARE_PART:
      return {
        ...state,
        updateSingleSparePart: action.payload,
      };
    case GET_COUNTRIES_LIST:
      return {
        ...state,
        countriesList: action.payload,
      };
    case GET_CYCLINDER_LIST:
      return {
        ...state,
        cyclinderList: action.payload,
      };
    case GET_SEATS_LIST:
      return {
        ...state,
        seatsList: action.payload,
      };
    case GET_MODEL_YEAR_LIST:
      return {
        ...state,
        modelYearList: action.payload,
      };
    case GET_FUEL_TYPE_LIST:
      return {
        ...state,
        fuelTypeList: action.payload,
      };
    case GET_DOOR_LIST:
      return {
        ...state,
        doorList: action.payload,
      };
    case GET_COLOR_LIST:
      return {
        ...state,
        colorList: action.payload,
      };
    case GET_SAFETY_LIST:
      return {
        ...state,
        safetyList: action.payload,
      };
    case GET_SINGLE_SAFETY_LIST:
      return {
        ...state,
        singleSafety: action.payload,
      };
    case GET_COMFORT_LIST:
      return {
        ...state,
        comfortList: action.payload,
      };
    case GET_SINGLE_COMFORT_LIST:
      return {
        ...state,
        singleComfirt: action.payload,
      };
    case ADD_COMFORT:
      return {
        ...state,
        addComfort: action.payload,
      };
    case ADD_COLOR_LIST:
      return {
        ...state,
        addColor: action.payload,
      };
    case ADD_SEAT_LIST:
      return {
        ...state,
        addSeat: action.payload,
      };
    case ADD_DOOR_LIST:
      return {
        ...state,
        addDoor: action.payload,
      };
    case ADD_FUEL_TYPE:
      return {
        ...state,
        fuelType: action.payload,
      };
    case ADD_MODEL_YEAR:
      return {
        ...state,
        addModelYear: action.payload,
      };
    case ADD_CYLINDER:
      return {
        ...state,
        addCylinder: action.payload,
      };
    case GET_SINGLE_CYCLINDER_LIST:
      return {
        ...state,
        singleCyclinder: action.payload,
      };
    case GET_SINGLE_MODEL_YEAR_LIST:
      return {
        ...state,
        singleModelYear: action.payload,
      };
    case GET_SINGLE_FUEL_TYPE_LIST:
      return {
        ...state,
        singleFuelType: action.payload,
      };
    case GET_SINGLE_DOOR_LIST:
      return {
        ...state,
        singleDoor: action.payload,
      };
    case GET_SINGLE_SEAT_LIST:
      return {
        ...state,
        singleSeat: action.payload,
      };
    case GET_SINGLE_COLOR_LIST:
      return {
        ...state,
        singleColor: action.payload,
      };
    case UPDATE_COMFORT:
      return {
        ...state,
        updateComfort: action.payload,
      };
    case UPDATE_COLOR_LIST:
      return {
        ...state,
        updateColor: action.payload,
      };
    case UPDATE_SEAT_LIST:
      return {
        ...state,
        updateSeat: action.payload,
      };
    case UPDATE_DOOR_LIST:
      return {
        ...state,
        updateDoor: action.payload,
      };
    case UPDATE_FUEL_TYPE:
      return {
        ...state,
        updateFuelType: action.payload,
      };
    case UPDATE_MODEL_YEAR:
      return {
        ...state,
        updateModelYear: action.payload,
      };
    case UPDATE_CYLINDER:
      return {
        ...state,
        updateCylinder: action.payload,
      };
    case UPDATE_SAFETY_LIST:
      return {
        ...state,
        updateSafety: action.payload,
      };
    case GET_SINGLE_CAR_BRAND:
      return {
        ...state,
        singleBrandDetail: action.payload,
      };
    case GET_SINGLE_PRODUCT_PART_DATA:
      return {
        ...state,
        singleProductPart: action.payload,
      };
    case GET_SERVICE_PROVIDER_LIST:
      return {
        ...state,
        serviceProvideList: action.payload,
      };
    case GET_CARMODEL_DATA:
      return {
        ...state,
        carModelList: action.payload,
      };
    case CONTACT_LIST:
      return {
        ...state,
        contactList: action.payload,
      };
    case GET_DATEWISE_ORDER:
      return {
        ...state,
        paymentList: action.payload,
      };
    case GET_CUSTOM_DATA_COUNTS:
      return {
        ...state,
        customDataCounts: action.payload,
      };
    case GET_PROFILE_USER:
      return { ...state, profileUser: action.payload };
    case GET_USER_SUBS:
      return { ...state, userSubs: action.payload };
    case GET_USER_CARPOSTS:
      return { ...state, userCarPosts: action.payload };
    case GET_LISTING_STATS:
      return { ...state, listingStats: action.payload };
    case GET_PLANS_FOR_BUSINESS:
      return { ...state, plansForBusiness: action.payload };
    default:
      return state;
  }
};

export default homeReducer;
